import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from '@angular/material/snack-bar';
import { CoreService } from '../../core/header/core.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SubscriptionService } from './subscription.service';
import { SubscriptionModel } from './subscription.model';

@Component({
    selector: 'convfact-subscription',
    templateUrl: './subscription.component.html',
    styleUrls: ['./subscription.component.css'],
    standalone: false
})

export class SubscriptionComponent implements OnInit {
    subscription = new SubscriptionModel();
    subscriptionList: SubscriptionModel[] = [];
    ready: boolean = false;
    constructor(private coreService: CoreService,
        private route: ActivatedRoute, private router: Router, public snackBar: MatSnackBar,
        private subscriptionService: SubscriptionService) {
    }

    ngOnInit() {
        this.coreService.setName("Suscripción");

        this.subscriptionService.getSubscriptionList()
            .then(data => {
                this.subscriptionList = data;
                this.ready = true;
            })
            .catch(data => {
                this.ready = true;
                this.subscriptionList = data;
            });
    }
}